// extracted by mini-css-extract-plugin
export default {"container":"CriteriaRubricAssessmentWithComments__container___dTffU","assessmentContainer":"CriteriaRubricAssessmentWithComments__assessmentContainer___eKJfT"};